export const BASE_URLS = {
    ESTABLISHMENTS: '/establecimientos',
};

export const COLORS_GENERIC = {
    primaryColor: '#323f47',
    primaryLight: '#476773'
}

export const APP_TAB_TITLE = {
    BO: 'BO',
    SIMP: 'SIMP'
}
